import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const SALES_ROUTES = new Set(['admin.sales', 'admin.sales.brand'])

export const checkSalesFeatureFlag: HermesGuardFn = async (to) => {
  if (!SALES_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.salesDashboard')) {
    return { name: 'brands' }
  }

  return undefined
}
